import {
  ADD_DOWNLOAD_SOFT,
  REMOVE_DOWNLOAD_SOFT,
  UPDATE_DOWNLOAD_SOFT_STATUS,
  UPDATE_DOWNLOAD_PROGRESS,
  ADD_WELCOMEIDS_TO_DOWNLOAD,
} from '../constants/download';

export const addDownload = soft => ({
  type: ADD_DOWNLOAD_SOFT,
  soft,
});

export const removeDownload = softID => ({
  type: REMOVE_DOWNLOAD_SOFT,
  softID,
});

export const updateDownloadProgress = params => ({
  type: UPDATE_DOWNLOAD_PROGRESS,
  ...params,
});

export const updateDownloadSoftStatus = param => ({
  type: UPDATE_DOWNLOAD_SOFT_STATUS,
  ...param,
});

export const addWelcomeIdToDownload = ids => ({
  type: ADD_WELCOMEIDS_TO_DOWNLOAD,
  ids,
});
